"use client";
import {
  __async
} from "../chunk-GOCCUU3Z.js";
import { jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { RampInstantSDK } from "@ramp-network/ramp-instant-sdk";
import { Network, OnRampAsset, OnRampProvider, getPortalBaseURL } from "@getpara/web-sdk";
import {
  getChainId,
  getContractAddressFromAsset,
  getCurrencyCodes,
  reverseCurrencyLookup,
  offRampSend
} from "../utils/index.js";
const TEST_MODE_FORBIDDEN = ["ETH_ETH", "ETH_USDC"];
const RampEmbed = ({
  para,
  appName,
  onRampConfig,
  onRampPurchase,
  isEmbedded,
  apiKey,
  onClose,
  setOnRampPurchase
}) => {
  const { currencyCodes } = getCurrencyCodes(onRampConfig, {
    provider: OnRampProvider.RAMP,
    purchaseType: onRampPurchase.type,
    walletType: onRampPurchase.walletType
  });
  const isMounted = useRef(false);
  useEffect(() => {
    if (!isMounted.current) {
      try {
        const widget = new RampInstantSDK({
          hostAppName: appName,
          swapAsset: currencyCodes.filter((code) => !onRampPurchase.testMode || !TEST_MODE_FORBIDDEN.includes(code)).join(","),
          fiatValue: onRampPurchase.fiatQuantity,
          fiatCurrency: onRampPurchase.fiat,
          hostLogoUrl: `${getPortalBaseURL(para.ctx)}/wordmark_black.svg`,
          hostApiKey: apiKey,
          userAddress: onRampPurchase.address,
          userEmailAddress: para.getEmail(),
          url: (onRampPurchase == null ? void 0 : onRampPurchase.testMode) ? "https://app.demo.ramp.network" : "https://app.ramp.network",
          enabledFlows: [onRampPurchase.type === "BUY" ? "ONRAMP" : "OFFRAMP"],
          useSendCryptoCallback: true,
          variant: "embedded-mobile",
          containerNode: document.getElementById("ramp-container")
        }).on("PURCHASE_CREATED", (e) => __async(void 0, null, function* () {
          const p = e.payload.purchase;
          const [network, asset] = onRampPurchase.testMode ? [Network.ETHEREUM, OnRampAsset.ETHEREUM] : reverseCurrencyLookup(onRampConfig.assetInfo, OnRampProvider.RAMP, p.asset.symbol) || [];
          const updated = yield para.ctx.client.updateOnRampPurchase({
            userId: para.getUserId(),
            walletId: onRampPurchase.walletId,
            externalWalletAddress: onRampPurchase.externalWalletAddress,
            purchaseId: onRampPurchase.id,
            updates: {
              providerKey: p.id,
              fiatQuantity: p.fiatValue,
              fiat: p.fiatCurrency,
              assetQuantity: p.cryptoAmount,
              asset,
              network
            }
          });
          setOnRampPurchase(updated);
        })).on("WIDGET_CLOSE", () => __async(void 0, null, function* () {
          onClose == null ? void 0 : onClose();
          if (!isEmbedded) {
            setTimeout(() => {
              if (typeof window !== "undefined") {
                window.close();
              }
            }, 5e3);
          }
        })).onSendCrypto((assetInfo, amount, address) => __async(void 0, null, function* () {
          try {
            const [network, asset] = reverseCurrencyLookup(onRampConfig.assetInfo, OnRampProvider.RAMP, assetInfo.symbol);
            const txHash = yield offRampSend(para, onRampPurchase, setOnRampPurchase, {
              assetQuantity: amount,
              destinationAddress: address,
              contractAddress: getContractAddressFromAsset(network, asset),
              chainId: getChainId(network),
              testMode: onRampPurchase.testMode
            });
            return { txHash };
          } catch (e) {
            console.error(e);
          }
        }));
        widget.show();
        isMounted.current = true;
      } catch (e) {
        console.error(e);
      }
    }
  }, []);
  return /* @__PURE__ */ jsx("div", { id: "ramp-container", style: { minWidth: "320px", width: "100%", height: "767px" } });
};
export {
  RampEmbed
};
